import React, { useState, useEffect } from 'react';
import { Table, Modal, Button } from 'react-bootstrap';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import axios from 'axios';
import '../Customize_Css/AddProductImage.css';
import '../Customize_Css/AddStock.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaBoxes, FaPlus, FaStore, FaFilter } from 'react-icons/fa';

const AddStock = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const AuthorizationToken = localStorage.getItem('token');
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [productId, setProductId] = useState(null);
    const [products, setProducts] = useState([]);
    const [productName, setProductName] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [productVendorId, setProductVendorId] = useState('');
    const [productWeightOption1, setProductWeightOption1] = useState({ weight: '', stock: '', price: '' });
    const [productWeightOption2, setProductWeightOption2] = useState({ weight: '', stock: '', price: '' });
    const [productWeightOption3, setProductWeightOption3] = useState({ weight: '', stock: '', price: '' });
    const [productWeightOption4, setProductWeightOption4] = useState({ weight: '', stock: '', price: '' });
    const [availabilityStatus, setAvailabilityStatus] = useState('');
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState('');
    const [selectedVendorName, setSelectedVendorName] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [productStates, setProductStates] = useState({});
    const [savedProducts, setSavedProducts] = useState([]);
    const [buyingPrice, setBuyingPrice] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [price, setPrice] = useState('');
    const [offerType, setOfferType] = useState('');
    const [offerPrice, setOfferPrice] = useState('');
    const [stock, setStock] = useState('');
    const [measurement, setMeasurement] = useState('');
    const [productIds, setProductIds] = useState([]);
    const [isCalendarised, setIsCalendarised] = useState(false);
    const [isIndianCalendar, setIsIndianCalendar] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [indianCalendarDate, setIndianCalendarDate] = useState('');
    const [errors, setErrors] = useState({});
    const [validFields, setValidFields] = useState({});
    const [noProductsMessage, setNoProductsMessage] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const calculateOfferPrice = (optionPrice) => {
        if (!optionPrice || !offerType || !offerPrice || isNaN(optionPrice) || isNaN(offerPrice)) return '';
        const priceNum = Number(optionPrice);
        const offerPriceNum = Number(offerPrice);
        if (offerType === 'fixed') {
            const result = priceNum - offerPriceNum;
            return result >= 0 ? result.toFixed(2) : 'Invalid';
        } else if (offerType === 'percentage') {
            const discount = (priceNum * offerPriceNum) / 100;
            const result = priceNum - discount;
            return result >= 0 ? result.toFixed(2) : 'Invalid';
        }
        return '';
    };

    const validateField = (id, value, productName = null) => {
        const isEmpty = (val) => !val || val.toString().trim() === '';
        const isValidPositiveNumber = (val) => !isNaN(val) && Number(val) > 0;

        const key = productName ? `${productName}-${id}` : id;

        const validationRules = {
            buyingPrice: {
                message: 'Buying Price must be a positive number',
                validator: isValidPositiveNumber,
            },
            sellingPrice: {
                message: (() => {
                    const buying = productName
                        ? productStates[productName]?.buyingPrice
                        : buyingPrice;
                    return buying && isValidPositiveNumber(buying) && isValidPositiveNumber(value) && Number(value) < Number(buying)
                        ? 'Selling Price must not be less than Buying Price'
                        : 'Selling Price must be a positive number';
                })(),
                validator: (val) => {
                    if (!isValidPositiveNumber(val)) return false;
                    const buying = productName
                        ? productStates[productName]?.buyingPrice
                        : buyingPrice;
                    if (buying && isValidPositiveNumber(buying) && Number(val) < Number(buying)) return false;
                    return true;
                },
            },
            price: {
                message: 'Price is required and must be a positive number',
                validator: isValidPositiveNumber,
            },
            offerType: {
                message: 'Offer Type is required',
                validator: (val) => ['fixed', 'percentage'].includes(val),
            },
            offerPrice: {
                message: 'Offer Price is required and must be a positive number',
                validator: (val) => isValidPositiveNumber(val) && (offerType !== 'percentage' || Number(val) <= 100),
            },
            productName: {
                message: 'Product Name is required',
                validator: (val) => !isEmpty(val),
            },
            productVendorId: {
                message: 'Product Vendor ID is required',
                validator: (val) => !isEmpty(val),
            },
            categoryName: {
                message: 'Category Name is required',
                validator: (val) => !isEmpty(val),
            },
            measurement: {
                message: 'Measurement is required',
                validator: (val) => !isEmpty(val),
            },
            availabilityStatus: {
                message: 'Availability Status is required',
                validator: (val) => !isEmpty(val),
            },
            weightOption1: {
                message: 'Fill Weight, Quantity and Price for Option 1. Offer price is calculated from Base Price and Offer Value above.',
                validator: (val) => {
                    const calculatedOfferPrice = calculateOfferPrice(val.price);
                    return (
                        val.weight?.trim() &&
                        isValidPositiveNumber(val.stock) &&
                        isValidPositiveNumber(val.price) &&
                        calculatedOfferPrice !== 'Invalid' &&
                        isValidPositiveNumber(calculatedOfferPrice)
                    );
                },
            },
            weightOption2: {
                message: 'If you add a weight for Option 2, fill Quantity and Price too.',
                validator: (val) => {
                    if (!val.weight?.trim()) return true;
                    const calculatedOfferPrice = calculateOfferPrice(val.price);
                    return (
                        isValidPositiveNumber(val.stock) &&
                        isValidPositiveNumber(val.price) &&
                        calculatedOfferPrice !== 'Invalid' &&
                        isValidPositiveNumber(calculatedOfferPrice)
                    );
                },
            },
            weightOption3: {
                message: 'If you add a weight for Option 3, fill Quantity and Price too.',
                validator: (val) => {
                    if (!val.weight?.trim()) return true;
                    const calculatedOfferPrice = calculateOfferPrice(val.price);
                    return (
                        isValidPositiveNumber(val.stock) &&
                        isValidPositiveNumber(val.price) &&
                        calculatedOfferPrice !== 'Invalid' &&
                        isValidPositiveNumber(calculatedOfferPrice)
                    );
                },
            },
            weightOption4: {
                message: 'If you add a weight for Option 4, fill Quantity and Price too.',
                validator: (val) => {
                    if (!val.weight?.trim()) return true;
                    const calculatedOfferPrice = calculateOfferPrice(val.price);
                    return (
                        isValidPositiveNumber(val.stock) &&
                        isValidPositiveNumber(val.price) &&
                        calculatedOfferPrice !== 'Invalid' &&
                        isValidPositiveNumber(calculatedOfferPrice)
                    );
                },
            },
            startDate: {
                message: 'Start Date is required',
                validator: (val) => !isEmpty(val),
            },
            endDate: {
                message: 'End Date is required',
                validator: (val) => !isEmpty(val),
            },
            indianCalendarDate: {
                message: 'Indian Calendar Date is required',
                validator: (val) => !isEmpty(val),
            },
        };

        const rule = validationRules[id];
        if (!rule) return true;

        const isValid = rule.validator(value);
        setErrors((prev) => ({
            ...prev,
            [key]: isValid ? '' : rule.message,
        }));
        setValidFields((prev) => ({
            ...prev,
            [key]: isValid,
        }));
        return isValid;
    };

    const handleShowModal = (
        product,
        selectedVendorName,
        category,
        measurement,
        stock,
        buyingPrice,
        sellingPrice,
        productId
    ) => {
        const buyingPriceKey = `${product}-buyingPrice`;
        const sellingPriceKey = `${product}-sellingPrice`;

        const isBuyingPriceValid = validateField('buyingPrice', productStates[product]?.buyingPrice || buyingPrice, product);
        const isSellingPriceValid = validateField('sellingPrice', productStates[product]?.sellingPrice || sellingPrice, product);

        if (!isBuyingPriceValid || !isSellingPriceValid) {
            return;
        }

        setProductName(product);
        setProductVendorId(selectedVendorName);
        setCategoryName(category);
        setMeasurement(measurement);
        setStock(stock);
        setBuyingPrice(buyingPrice);
        setSellingPrice(sellingPrice);
        setPrice(productStates[product]?.sellingPrice || sellingPrice);
        setProductId(productId);
        setErrors((prev) => {
            const next = {};
            Object.keys(prev).forEach((key) => {
                if (key.includes('-')) next[key] = prev[key];
            });
            return next;
        });
        setValidFields((prev) => {
            const next = {};
            Object.keys(prev).forEach((key) => {
                if (key.includes('-')) next[key] = prev[key];
            });
            return next;
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setErrors({});
        setValidFields({});
        setPrice('');
        setOfferType('');
        setOfferPrice('');
        setProductWeightOption1({ weight: '', stock: '', price: '' });
        setProductWeightOption2({ weight: '', stock: '', price: '' });
        setProductWeightOption3({ weight: '', stock: '', price: '' });
        setProductWeightOption4({ weight: '', stock: '', price: '' });
        setAvailabilityStatus('');
        setIsCalendarised(false);
        setIsIndianCalendar(false);
        setStartDate('');
        setEndDate('');
        setIndianCalendarDate('');
    };

    const validateProductDetailsStockForm = () => {
        let isValid = true;
        const fieldsToValidate = [
            { id: 'productName', value: productName },
            { id: 'productVendorId', value: productVendorId },
            { id: 'categoryName', value: categoryName },
            { id: 'measurement', value: productStates[productName]?.measurement || measurement },
            { id: 'availabilityStatus', value: availabilityStatus },
            { id: 'weightOption1', value: productWeightOption1 },
            { id: 'price', value: price },
            { id: 'offerType', value: offerType },
            { id: 'offerPrice', value: offerPrice },
        ];

        if (productWeightOption2.weight?.trim()) {
            fieldsToValidate.push({ id: 'weightOption2', value: productWeightOption2 });
        }
        if (productWeightOption3.weight?.trim()) {
            fieldsToValidate.push({ id: 'weightOption3', value: productWeightOption3 });
        }
        if (productWeightOption4.weight?.trim()) {
            fieldsToValidate.push({ id: 'weightOption4', value: productWeightOption4 });
        }
        if (isCalendarised) {
            fieldsToValidate.push(
                { id: 'startDate', value: startDate },
                { id: 'endDate', value: endDate }
            );
        }
        if (isIndianCalendar) {
            fieldsToValidate.push({ id: 'indianCalendarDate', value: indianCalendarDate });
        }

        fieldsToValidate.forEach(({ id, value }) => {
            if (!validateField(id, value)) {
                isValid = false;
            }
        });

        return isValid;
    };

    const handleSubmit = async () => {
        if (!validateProductDetailsStockForm()) {
            return;
        }

        const productDetails = {
            productName,
            productVendorId,
            categoryName,
            measurement: productStates[productName]?.measurement || measurement,
            stock: productStates[productName]?.stock || stock,
            buyingPrice: productStates[productName]?.buyingPrice || buyingPrice,
            sellingPrice: productStates[productName]?.sellingPrice || sellingPrice,
            price,
            offerType,
            offerPrice,
            productWeightOption1: {
                ...productWeightOption1,
                offerPrice: calculateOfferPrice(productWeightOption1.price),
            },
            productWeightOption2: productWeightOption2.weight?.trim()
                ? { ...productWeightOption2, offerPrice: calculateOfferPrice(productWeightOption2.price) }
                : null,
            productWeightOption3: productWeightOption3.weight?.trim()
                ? { ...productWeightOption3, offerPrice: calculateOfferPrice(productWeightOption3.price) }
                : null,
            productWeightOption4: productWeightOption4.weight?.trim()
                ? { ...productWeightOption4, offerPrice: calculateOfferPrice(productWeightOption4.price) }
                : null,
            productVendorName: selectedVendorName,
            calendarised: isCalendarised,
            indianCalendar: isIndianCalendar,
            startDate: isCalendarised ? startDate : null,
            endDate: isCalendarised ? endDate : null,
            indianCalendarDate: isIndianCalendar ? indianCalendarDate : null,
        };

        try {
            const response = await axios.put(
                `${BASE_URL}/products/api/productDetails/${epicxTenantId}/stocks/productVendor?productVendorName=${encodeURIComponent(selectedVendorName)}&productId=${productId}`,
                productDetails,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${AuthorizationToken}`,
                    },
                }
            );
            setSavedProducts((prevSavedProducts) => [
                ...prevSavedProducts,
                { productName, categoryName },
            ]);
            handleCloseModal();
        } catch (error) {
            console.error('Error updating product:', error.response?.data);
            setErrors((prev) => ({
                ...prev,
                submit: 'Failed to update product. Please try again.',
            }));
        }
    };

    const fetchVendors = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}`, {
                headers: {
                    Authorization: `Bearer ${AuthorizationToken}`,
                },
            });
            setVendors(response.data.vendors);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    const handleVendorChange = (e) => {
        const vendorId = e.target.value;
        setSelectedVendor(vendorId);
        setCurrentPage(1);
        const vendor = vendors.find((v) => v._id === vendorId);
        setSelectedVendorName(vendor ? vendor.vendorName : '');
        setSelectedCategory('');
    };

    const handleCategoryChange = (e) => {
        setSelectedCategory(e.target.value);
        setCurrentPage(1);
    };

    useEffect(() => {
        const fetchProducts = async () => {
            if (!selectedVendorName) {
                setNoProductsMessage('Please select a vendor to view products.');
                setProducts([]);
                setCategories([]);
                return;
            }
            try {
                const url = `${BASE_URL}/products/api/productDetails/${epicxTenantId}/stock/productVendor?productVendorName=${encodeURIComponent(selectedVendorName)}`;
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${AuthorizationToken}`,
                    },
                });
                if (!response.ok) {
                    if (response.status === 404) {
                        setNoProductsMessage(
                            `No products available for the selected vendor in the ${selectedCategory || 'current'} section.`
                        );
                        setProducts([]);
                        setCategories([]);
                        return;
                    }
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setProducts(data);
                setNoProductsMessage('');
                const ids = data.map((product) => product._id);
                setProductIds(ids);
                const uniqueCategories = [...new Set(data.map((product) => product.categoryName))];
                setCategories(uniqueCategories);
            } catch (error) {
                console.error('Error fetching products:', error);
                setNoProductsMessage('Error fetching products. Please try again.');
                setProducts([]);
                setCategories([]);
            }
        };
        fetchProducts();
    }, [selectedVendorName, selectedCategory, BASE_URL, AuthorizationToken]);

    useEffect(() => {
        if (products && products.length > 0) {
            const initialStates = {};
            products.forEach((product) => {
                initialStates[product.productName] = {
                    measurement: product.measurement || '',
                    stock: product.stock || '',
                    buyingPrice: product.buyingPrice || '',
                    sellingPrice: product.sellingPrice || '',
                };
            });
            setProductStates(initialStates);
        }
    }, [products]);

    const handlePriceChange = (product, priceType, value) => {
        setProductStates((prevState) => ({
            ...prevState,
            [product]: {
                ...prevState[product],
                [priceType]: value,
            },
        }));
        if (priceType === 'sellingPrice') {
            setPrice(value);
        }
        validateField(priceType, value, product);
        if (priceType === 'buyingPrice') {
            const currentSelling = productStates[product]?.sellingPrice;
            if (currentSelling) validateField('sellingPrice', currentSelling, product);
        }
    };

    const filteredProducts = selectedCategory
        ? products.filter((product) => product.categoryName === selectedCategory)
        : products;

    const productsToDisplay =
        filteredProducts && filteredProducts.length > 0
            ? filteredProducts.filter(
                  (product) =>
                      !savedProducts.some(
                          (savedProduct) =>
                              savedProduct.productName === product.productName &&
                              savedProduct.categoryName === product.categoryName
                      )
              )
            : [];

    const totalPages = Math.ceil(productsToDisplay.length / itemsPerPage);
    const indexOfLastProduct = currentPage * itemsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
    const currentProducts = productsToDisplay.slice(indexOfFirstProduct, indexOfLastProduct);

    useEffect(() => {
        if (totalPages === 0 && currentPage !== 1) {
            setCurrentPage(1);
        } else if (totalPages > 0 && currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [currentPage, totalPages]);

    return (
        <>
            <Sidebar />
            <div className="add-stock-page">
                <div className="add-stock-content">
                    <header className="add-stock-hero">
                        <div>
                            <p className="add-stock-kicker">Inventory</p>
                            <h1>Add Stock</h1>
                            <p>Select a vendor and category, enter prices, then add stock details.</p>
                        </div>
                        <button
                            type="button"
                            className="add-stock-back-btn"
                            onClick={() => navigate('/viewStocks')}
                        >
                            <FaArrowLeft aria-hidden="true" /> Back to Stocks
                        </button>
                    </header>

                    <section className="add-stock-filters" aria-label="Stock product filters">
                        <div className="add-stock-filter">
                            <label htmlFor="vendorDropdown">Vendor</label>
                            <div className="add-stock-select-wrap">
                                <FaStore aria-hidden="true" />
                        <select
                            className="form-select"
                            id="vendorDropdown"
                            value={selectedVendor}
                            onChange={handleVendorChange}
                            onClick={fetchVendors}
                        >
                            <option value="">Select Vendor</option>
                            {vendors.map((vendor) => (
                                <option key={vendor._id} value={vendor._id}>
                                    {vendor.vendorName}
                                </option>
                            ))}
                        </select>
                            </div>
                        </div>
                        <div className="add-stock-filter">
                            <label htmlFor="categoryDropdown">Category</label>
                            <div className="add-stock-select-wrap">
                                <FaFilter aria-hidden="true" />
                        <select
                            className="form-select"
                            id="categoryDropdown"
                            value={selectedCategory}
                            onChange={handleCategoryChange}
                            disabled={!selectedVendorName}
                        >
                            <option value="">All Categories</option>
                            {categories.map((category) => (
                                <option key={category} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                            </div>
                        </div>
                    </section>

                    <div className="add-stock-card">
                        <div className="add-stock-card-head">
                            <div>
                                <h2>Available Products</h2>
                                <p>
                                    {selectedVendorName
                                        ? `Add stock for products from ${selectedVendorName}`
                                        : 'Select a vendor to view products'}
                                </p>
                            </div>
                            <span className="add-stock-count">
                                <FaBoxes aria-hidden="true" />
                                {productsToDisplay.length} {productsToDisplay.length === 1 ? 'product' : 'products'}
                            </span>
                        </div>
                        <div className="add-stock-card-body">
                            <div className="add-stock-table-wrap">
                                <Table responsive className="add-stock-table">
                                    <thead>
                                        <tr>
                                            <th>Product Name</th>
                                            <th>Category Name</th>
                                            <th>Measurement</th>
                                            <th>
                                                Buying Price (Per Item) <span className="add-stock-required">*</span>
                                            </th>
                                            <th>
                                                Selling Price (Per Item) <span className="add-stock-required">*</span>
                                            </th>
                                            <th className="add-stock-action-cell">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentProducts.length > 0 ? (
                                            currentProducts.map((product) => (
                                                    <tr key={`${product.categoryName}-${product.productName}`}>
                                                        <td><strong className="add-stock-product-name">{product.productName}</strong></td>
                                                        <td><span className="add-stock-category">{product.categoryName}</span></td>
                                                        <td><span className="add-stock-measurement">{product.measurement || 'N/A'}</span></td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${
                                                                    errors[`${product.productName}-buyingPrice`]
                                                                        ? 'is-invalid'
                                                                        : validFields[`${product.productName}-buyingPrice`]
                                                                        ? 'is-valid'
                                                                        : ''
                                                                }`}
                                                                placeholder="Enter Buying Price"
                                                                value={productStates[product.productName]?.buyingPrice || ''}
                                                                onChange={(e) =>
                                                                    handlePriceChange(product.productName, 'buyingPrice', e.target.value)
                                                                }
                                                            />
                                                            {errors[`${product.productName}-buyingPrice`] && (
                                                                <small className="text-danger">
                                                                    {errors[`${product.productName}-buyingPrice`]}
                                                                </small>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${
                                                                    errors[`${product.productName}-sellingPrice`]
                                                                        ? 'is-invalid'
                                                                        : validFields[`${product.productName}-sellingPrice`]
                                                                        ? 'is-valid'
                                                                        : ''
                                                                }`}
                                                                placeholder="Enter Selling Price"
                                                                value={productStates[product.productName]?.sellingPrice || ''}
                                                                onChange={(e) =>
                                                                    handlePriceChange(product.productName, 'sellingPrice', e.target.value)
                                                                }
                                                            />
                                                            {errors[`${product.productName}-sellingPrice`] && (
                                                                <small className="text-danger">
                                                                    {errors[`${product.productName}-sellingPrice`]}
                                                                </small>
                                                            )}
                                                        </td>
                                                        <td className="add-stock-action-cell">
                                                            <button
                                                                className="add-stock-row-btn"
                                                                onClick={() =>
                                                                    handleShowModal(
                                                                        product.productName,
                                                                        selectedVendorName,
                                                                        product.categoryName,
                                                                        productStates[product.productName]?.measurement || '',
                                                                        productStates[product.productName]?.stock || '',
                                                                        productStates[product.productName]?.buyingPrice || '',
                                                                        productStates[product.productName]?.sellingPrice || '',
                                                                        product._id
                                                                    )
                                                                }
                                                            >
                                                                <FaPlus aria-hidden="true" /> Add Details
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                        ) : (
                                            <tr>
                                                <td colSpan={6} className="p-0 border-0">
                                                    <div className="stocks-list-empty-state">
                                                        <div className="stocks-list-empty-state-icon">
                                                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                                <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </div>
                                                        <h6 className="stocks-list-empty-state-title">No products to display</h6>
                                                        <p className="stocks-list-empty-state-message">
                                                            {noProductsMessage ||
                                                                (filteredProducts && filteredProducts.length > 0
                                                                    ? 'All products in this list have been processed. Select another category or vendor to add more.'
                                                                    : 'Select a vendor and category to see products here. Use "Add More" to add stock for listed items.')}
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                        {productsToDisplay.length > 0 && (
                            <div className="add-stock-card-footer">
                                <span>
                                    Showing {indexOfFirstProduct + 1}–{Math.min(indexOfLastProduct, productsToDisplay.length)} of{' '}
                                    {productsToDisplay.length}
                                </span>
                                <nav aria-label="Available stock products pagination">
                                    <ul className="pagination mb-0">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(1)} aria-label="First page">
                                                «
                                            </button>
                                        </li>
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
                                                aria-label="Previous page"
                                            >
                                                ‹
                                            </button>
                                        </li>
                                        <li className="page-item active">
                                            <button className="page-link" aria-current="page">
                                                {currentPage}
                                            </button>
                                        </li>
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage((page) => Math.min(page + 1, totalPages))}
                                                aria-label="Next page"
                                            >
                                                ›
                                            </button>
                                        </li>
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(totalPages)}
                                                aria-label="Last page"
                                            >
                                                »
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        )}
                    </div>
                    <Modal show={showModal} onHide={handleCloseModal} size="xl" className="add-stock-modal">
                        <Modal.Header closeButton className="add-stock-modal-header">
                            <Modal.Title>
                                <span className="add-stock-modal-icon"><FaBoxes aria-hidden="true" /></span>
                                <span>
                                    <small>Inventory</small>
                                    Add Stock for Product
                                </span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="add-stock-modal-body">
                            <div className="card add-stock-modal-card">
                                <div className="card-header add-stock-modal-card-head">
                                    <h5>Weight and Price Information</h5>
                                    <p>Configure availability, offers, weight options, and calendar settings.</p>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="productName" className="form-label">
                                                Product Name
                                            </label>
                                            <span style={{ color: 'red' }}>*</span>
                                            <input
                                                type="text"
                                                className={`form-control bg-light ${
                                                    errors.productName ? 'is-invalid' : validFields.productName ? 'is-valid' : ''
                                                }`}
                                                id="productName"
                                                placeholder="Enter Product Name"
                                                value={productName}
                                                readOnly
                                            />
                                            {errors.productName && (
                                                <small className="text-danger">{errors.productName}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="availabilityStatus" className="form-label">
                                                Availability Status
                                            </label>
                                            <span style={{ color: 'red' }}>*</span>
                                            <select
                                                className={`form-select bg-light ${
                                                    errors.availabilityStatus
                                                        ? 'is-invalid'
                                                        : validFields.availabilityStatus
                                                        ? 'is-valid'
                                                        : ''
                                                }`}
                                                id="availabilityStatus"
                                                value={availabilityStatus}
                                                onChange={(e) => {
                                                    setAvailabilityStatus(e.target.value);
                                                    validateField('availabilityStatus', e.target.value);
                                                }}
                                            >
                                                <option value="" disabled>
                                                    Select status
                                                </option>
                                                <option value="available">Available</option>
                                                <option value="outOfStock">Out of Stock</option>
                                                <option value="discontinued">Discontinued</option>
                                            </select>
                                            {errors.availabilityStatus && (
                                                <small className="text-danger">{errors.availabilityStatus}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="price" className="form-label">
                                                Base Price
                                            </label>
                                            <span style={{ color: 'red' }}>*</span>
                                            <input
                                                type="text"
                                                className={`form-control bg-light ${
                                                    errors.price ? 'is-invalid' : validFields.price ? 'is-valid' : ''
                                                }`}
                                                id="price"
                                                placeholder="Enter Base Price"
                                                value={price}
                                                onChange={(e) => {
                                                    const newPrice = e.target.value;
                                                    setPrice(newPrice);
                                                    validateField('price', newPrice);
                                                    setProductStates((prevState) => ({
                                                        ...prevState,
                                                        [productName]: {
                                                            ...prevState[productName],
                                                            sellingPrice: newPrice,
                                                        },
                                                    }));
                                                    validateField('sellingPrice', newPrice, productName);
                                                }}
                                            />
                                            {errors.price && (
                                                <small className="text-danger">{errors.price}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="offerType" className="form-label">
                                                Offer Type
                                            </label>
                                            <span style={{ color: 'red' }}>*</span>
                                            <select
                                                className={`form-select bg-light ${
                                                    errors.offerType ? 'is-invalid' : validFields.offerType ? 'is-valid' : ''
                                                }`}
                                                id="offerType"
                                                value={offerType}
                                                onChange={(e) => {
                                                    setOfferType(e.target.value);
                                                    validateField('offerType', e.target.value);
                                                    validateField('weightOption1', productWeightOption1);
                                                    if (productWeightOption2.weight?.trim()) validateField('weightOption2', productWeightOption2);
                                                    if (productWeightOption3.weight?.trim()) validateField('weightOption3', productWeightOption3);
                                                    if (productWeightOption4.weight?.trim()) validateField('weightOption4', productWeightOption4);
                                                }}
                                            >
                                                <option value="" disabled>
                                                    Select Offer Type
                                                </option>
                                                <option value="fixed">Fixed</option>
                                                <option value="percentage">Percentage</option>
                                            </select>
                                            {errors.offerType && (
                                                <small className="text-danger">{errors.offerType}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="offerPrice" className="form-label">
                                                Offer Value
                                            </label>
                                            <span style={{ color: 'red' }}>*</span>
                                            <input
                                                type="text"
                                                className={`form-control bg-light ${
                                                    errors.offerPrice ? 'is-invalid' : validFields.offerPrice ? 'is-valid' : ''
                                                }`}
                                                id="offerPrice"
                                                placeholder={offerType === 'percentage' ? 'Enter Percentage' : 'Enter Fixed Amount'}
                                                value={offerPrice}
                                                onChange={(e) => {
                                                    setOfferPrice(e.target.value);
                                                    validateField('offerPrice', e.target.value);
                                                    validateField('weightOption1', productWeightOption1);
                                                    if (productWeightOption2.weight?.trim()) validateField('weightOption2', productWeightOption2);
                                                    if (productWeightOption3.weight?.trim()) validateField('weightOption3', productWeightOption3);
                                                    if (productWeightOption4.weight?.trim()) validateField('weightOption4', productWeightOption4);
                                                }}
                                            />
                                            {errors.offerPrice && (
                                                <small className="text-danger">{errors.offerPrice}</small>
                                            )}
                                        </div>
                                        <div className="col-12 mt-3 mb-2">
                                            <p className="text-muted small mb-3">Add at least <strong>one</strong> weight option (e.g. 1 kg, 5kg). Options 2–4 are optional.</p>

                                            {/* Weight Option 1 - Required */}
                                            <div className={`weight-option-block mb-3 p-3 rounded ${errors.weightOption1 ? 'border border-danger' : 'border'}`}>
                                                <p className="mb-2 fw-semibold small">Weight Option 1 <span className="text-danger">*</span></p>
                                                <div className="row g-2 align-items-end">
                                                    <div className="col-md-3">
                                                        <label htmlFor="weightOption1" className="form-label small mb-0">Weight</label>
                                                        <span className="small text-muted d-block">e.g. 1 kg, 5 kg</span>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption1 ? 'is-invalid' : validFields.weightOption1 ? 'is-valid' : ''}`} id="weightOption1" placeholder="e.g. 1 kg" value={productWeightOption1.weight} onChange={(e) => { const newOption = { ...productWeightOption1, weight: e.target.value }; setProductWeightOption1(newOption); validateField('weightOption1', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="stockOption1" className="form-label small mb-0">Quantity (Stock)</label>
                                                        <span className="small text-muted d-block">e.g. 50</span>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption1 ? 'is-invalid' : validFields.weightOption1 ? 'is-valid' : ''}`} id="stockOption1" placeholder="e.g. 50" value={productWeightOption1.stock} onChange={(e) => { const newOption = { ...productWeightOption1, stock: e.target.value }; setProductWeightOption1(newOption); validateField('weightOption1', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="priceOption1" className="form-label small mb-0">Price (₹)</label>
                                                        <span className="small text-muted d-block">e.g. 100</span>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption1 ? 'is-invalid' : validFields.weightOption1 ? 'is-valid' : ''}`} id="priceOption1" placeholder="e.g. 100" value={productWeightOption1.price} onChange={(e) => { const newOption = { ...productWeightOption1, price: e.target.value }; setProductWeightOption1(newOption); validateField('weightOption1', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label small mb-0 text-muted">Offer Price (auto)</label>
                                                        <div className={`form-control form-control-sm bg-light border-0 py-2 ${errors.weightOption1 ? 'text-danger' : validFields.weightOption1 ? 'text-success' : ''}`}>{calculateOfferPrice(productWeightOption1.price) || 'N/A'}</div>
                                                    </div>
                                                </div>
                                                {errors.weightOption1 && <small className="text-danger d-block mt-1">{errors.weightOption1}</small>}
                                            </div>

                                            {/* Weight Option 2 - Optional */}
                                            <div className={`weight-option-block mb-3 p-3 rounded ${errors.weightOption2 ? 'border border-danger' : 'border'}`}>
                                                <p className="mb-2 fw-semibold small text-muted">Weight Option 2 <span className="small">(optional)</span></p>
                                                <div className="row g-2 align-items-end">
                                                    <div className="col-md-3">
                                                        <label htmlFor="weightOption2" className="form-label small mb-0">Weight</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption2 ? 'is-invalid' : validFields.weightOption2 ? 'is-valid' : ''}`} id="weightOption2" placeholder="e.g. 5 kg" value={productWeightOption2.weight} onChange={(e) => { const newOption = { ...productWeightOption2, weight: e.target.value }; setProductWeightOption2(newOption); validateField('weightOption2', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="stockOption2" className="form-label small mb-0">Quantity (Stock)</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption2 ? 'is-invalid' : validFields.weightOption2 ? 'is-valid' : ''}`} id="stockOption2" placeholder="e.g. 50" value={productWeightOption2.stock} onChange={(e) => { const newOption = { ...productWeightOption2, stock: e.target.value }; setProductWeightOption2(newOption); validateField('weightOption2', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="priceOption2" className="form-label small mb-0">Price (₹)</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption2 ? 'is-invalid' : validFields.weightOption2 ? 'is-valid' : ''}`} id="priceOption2" placeholder="e.g. 80" value={productWeightOption2.price} onChange={(e) => { const newOption = { ...productWeightOption2, price: e.target.value }; setProductWeightOption2(newOption); validateField('weightOption2', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label small mb-0 text-muted">Offer Price (auto)</label>
                                                        <div className={`form-control form-control-sm bg-light border-0 py-2 ${errors.weightOption2 ? 'text-danger' : validFields.weightOption2 ? 'text-success' : ''}`}>{calculateOfferPrice(productWeightOption2.price) || 'N/A'}</div>
                                                    </div>
                                                </div>
                                                {errors.weightOption2 && <small className="text-danger d-block mt-1">{errors.weightOption2}</small>}
                                            </div>

                                            {/* Weight Option 3 - Optional */}
                                            <div className={`weight-option-block mb-3 p-3 rounded ${errors.weightOption3 ? 'border border-danger' : 'border'}`}>
                                                <p className="mb-2 fw-semibold small text-muted">Weight Option 3 <span className="small">(optional)</span></p>
                                                <div className="row g-2 align-items-end">
                                                    <div className="col-md-3">
                                                        <label htmlFor="weightOption3" className="form-label small mb-0">Weight</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption3 ? 'is-invalid' : validFields.weightOption3 ? 'is-valid' : ''}`} id="weightOption3" placeholder="e.g. 5 kg" value={productWeightOption3.weight} onChange={(e) => { const newOption = { ...productWeightOption3, weight: e.target.value }; setProductWeightOption3(newOption); validateField('weightOption3', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="stockOption3" className="form-label small mb-0">Quantity (Stock)</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption3 ? 'is-invalid' : validFields.weightOption3 ? 'is-valid' : ''}`} id="stockOption3" placeholder="e.g. 50" value={productWeightOption3.stock} onChange={(e) => { const newOption = { ...productWeightOption3, stock: e.target.value }; setProductWeightOption3(newOption); validateField('weightOption3', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="priceOption3" className="form-label small mb-0">Price (₹)</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption3 ? 'is-invalid' : validFields.weightOption3 ? 'is-valid' : ''}`} id="priceOption3" placeholder="e.g. 80" value={productWeightOption3.price} onChange={(e) => { const newOption = { ...productWeightOption3, price: e.target.value }; setProductWeightOption3(newOption); validateField('weightOption3', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label small mb-0 text-muted">Offer Price (auto)</label>
                                                        <div className={`form-control form-control-sm bg-light border-0 py-2 ${errors.weightOption3 ? 'text-danger' : validFields.weightOption3 ? 'text-success' : ''}`}>{calculateOfferPrice(productWeightOption3.price) || 'N/A'}</div>
                                                    </div>
                                                </div>
                                                {errors.weightOption3 && <small className="text-danger d-block mt-1">{errors.weightOption3}</small>}
                                            </div>

                                            {/* Weight Option 4 - Optional */}
                                            <div className={`weight-option-block mb-3 p-3 rounded ${errors.weightOption4 ? 'border border-danger' : 'border'}`}>
                                                <p className="mb-2 fw-semibold small text-muted">Weight Option 4 <span className="small">(optional)</span></p>
                                                <div className="row g-2 align-items-end">
                                                    <div className="col-md-3">
                                                        <label htmlFor="weightOption4" className="form-label small mb-0">Weight</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption4 ? 'is-invalid' : validFields.weightOption4 ? 'is-valid' : ''}`} id="weightOption4" placeholder="e.g. 5 kg" value={productWeightOption4.weight} onChange={(e) => { const newOption = { ...productWeightOption4, weight: e.target.value }; setProductWeightOption4(newOption); validateField('weightOption4', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="stockOption4" className="form-label small mb-0">Quantity (Stock)</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption4 ? 'is-invalid' : validFields.weightOption4 ? 'is-valid' : ''}`} id="stockOption4" placeholder="e.g. 50" value={productWeightOption4.stock} onChange={(e) => { const newOption = { ...productWeightOption4, stock: e.target.value }; setProductWeightOption4(newOption); validateField('weightOption4', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="priceOption4" className="form-label small mb-0">Price (₹)</label>
                                                        <input type="text" className={`form-control form-control-sm bg-light ${errors.weightOption4 ? 'is-invalid' : validFields.weightOption4 ? 'is-valid' : ''}`} id="priceOption4" placeholder="e.g. 80" value={productWeightOption4.price} onChange={(e) => { const newOption = { ...productWeightOption4, price: e.target.value }; setProductWeightOption4(newOption); validateField('weightOption4', newOption); }} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label small mb-0 text-muted">Offer Price (auto)</label>
                                                        <div className={`form-control form-control-sm bg-light border-0 py-2 ${errors.weightOption4 ? 'text-danger' : validFields.weightOption4 ? 'text-success' : ''}`}>{calculateOfferPrice(productWeightOption4.price) || 'N/A'}</div>
                                                    </div>
                                                </div>
                                                {errors.weightOption4 && <small className="text-danger d-block mt-1">{errors.weightOption4}</small>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>Calendarised</label>
                                                <div className="form-check form-switch" style={{ marginLeft: '25px' }}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="calendarised"
                                                        checked={isCalendarised}
                                                        style={{
                                                            backgroundColor: isCalendarised ? '#01B074' : '',
                                                            fontSize: '25px',
                                                            border: isCalendarised ? 'none' : '',
                                                            outline: isCalendarised ? 'none' : '',
                                                        }}
                                                        onChange={() => setIsCalendarised(!isCalendarised)}
                                                    />
                                                    <label className="form-check-label" htmlFor="calendarised"></label>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <label>Indian Calendar</label>
                                                <div className="form-check form-switch" style={{ marginLeft: '25px' }}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="indianCalendar"
                                                        checked={isIndianCalendar}
                                                        style={{
                                                            backgroundColor: isIndianCalendar ? '#01B074' : '',
                                                            fontSize: '25px',
                                                            border: isIndianCalendar ? 'none' : '',
                                                            outline: isIndianCalendar ? 'none' : '',
                                                        }}
                                                        onChange={() => setIsIndianCalendar(!isIndianCalendar)}
                                                    />
                                                    <label className="form-check-label" htmlFor="indianCalendar"></label>
                                                </div>
                                            </div>
                                        </div>
                                        {isCalendarised && (
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label htmlFor="startDate" className="form-label">
                                                        Start Date
                                                    </label>
                                                    <span style={{ color: 'red' }}>*</span>
                                                    <input
                                                        type="date"
                                                        className={`form-control bg-light ${
                                                            errors.startDate ? 'is-invalid' : validFields.startDate ? 'is-valid' : ''
                                                        }`}
                                                        id="startDate"
                                                        value={startDate}
                                                        onChange={(e) => {
                                                            setStartDate(e.target.value);
                                                            validateField('startDate', e.target.value);
                                                        }}
                                                    />
                                                    {errors.startDate && (
                                                        <small className="text-danger">{errors.startDate}</small>
                                                    )}
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="endDate" className="form-label">
                                                        End Date
                                                    </label>
                                                    <span style={{ color: 'red' }}>*</span>
                                                    <input
                                                        type="date"
                                                        className={`form-control bg-light ${
                                                            errors.endDate ? 'is-invalid' : validFields.endDate ? 'is-valid' : ''
                                                        }`}
                                                        id="endDate"
                                                        value={endDate}
                                                        onChange={(e) => {
                                                            setEndDate(e.target.value);
                                                            validateField('endDate', e.target.value);
                                                        }}
                                                    />
                                                    {errors.endDate && (
                                                        <small className="text-danger">{errors.endDate}</small>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {isIndianCalendar && (
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label htmlFor="indianCalendarDate" className="form-label">
                                                        Indian Calendar Date
                                                    </label>
                                                    <span style={{ color: 'red' }}>*</span>
                                                    <input
                                                        type="date"
                                                        className={`form-control bg-light ${
                                                            errors.indianCalendarDate
                                                                ? 'is-invalid'
                                                                : validFields.indianCalendarDate
                                                                ? 'is-valid'
                                                                : ''
                                                        }`}
                                                        id="indianCalendarDate"
                                                        value={indianCalendarDate}
                                                        onChange={(e) => {
                                                            setIndianCalendarDate(e.target.value);
                                                            validateField('indianCalendarDate', e.target.value);
                                                        }}
                                                    />
                                                    {errors.indianCalendarDate && (
                                                        <small className="text-danger">{errors.indianCalendarDate}</small>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="add-stock-modal-footer">
                            <Button
                                onClick={handleCloseModal}
                                className="add-stock-cancel-btn"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleSubmit}
                                className="add-stock-submit-btn"
                            >
                                Save Stock
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                {!showModal && <Footer />}
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={true}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    style={{ zIndex: 9999 }}
                />
            </div>
            
        </>
    );
};

export default AddStock;